<template>
  <div>
    <div class="hgroup">
      <h2>Down for Maintenance</h2>
    </div>
    <div class="boxType1">
      <p>Sorry, this site is temporarily down for maintenance. Please check back soon.</p>
    </div>
  </div>
</template>

<script>
import appDataApi from '@/api/app-data'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'AppMaintenance',
  mixins: [ajaxHandlerMixin],
  created () {
    this.checkMaintenance()
  },
  methods: {
    checkMaintenance () {
      appDataApi.authStatus().then(response => {
        this.$router.replace({ name: 'Main' })
      }).catch(this.handleAjaxError)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/AppMaintenance.vue